import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { SLabel, STextField } from './styled';
import { Box as MuiBox } from '@mui/material';
import MfaMode from 'lib/enums/mfaMode';
import { FormControl, FormSmallSwitch, JamIcon } from 'components/ui';
import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'services/auth';
import FormPhoneInput from 'components/ui/FormPhoneInput';

export default function Contact({ isPhoneRequired = false }) {
  const { t } = useTranslation();
  const workspaceMfaMode = useSelector(authSelectors.getWorkspaceMfaMode);
  return (
    <Accordion
      title={t('Contact') + ' *'}
      startAdornment={<JamIcon icon="envelope" />}
    >
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('Email') + ' *'}>
          <STextField
            dataId="email-input"
            name="email"
            placeholder={t('Email')}
          />
        </FormControl>

        <FormPhoneInput
          name="phone"
          data-id="phone"
          label={`${t('Phone number')}${isPhoneRequired ? ' *' : ''}`}
        />
      </MuiBox>

      {[MfaMode.OptionalEnabled, MfaMode.OptionalDisabled].includes(
        workspaceMfaMode
      ) ? (
        <MuiBox display="flex" alignItems="center" mb={2}>
          <SLabel>{t('Require Multifactor Authentication')}</SLabel>
          <FormSmallSwitch name={'isMfaRequired'} />
        </MuiBox>
      ) : null}
    </Accordion>
  );
}
